import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLanguage } from '@planter/common';
import * as React from 'react';
import WarningIcon from '../../../components/icons/WarningIcon';
var NotifyIngredients = React.memo(function (className) {
    var t = useLanguage()[0];
    return (_jsxs("div", { className: "rounded-xl bg-yellow p-3 ".concat(className), children: [_jsxs("div", { className: "flex", children: [_jsx(WarningIcon, {}), _jsx("p", { className: "pl-3 font-medium", children: t('warning') })] }), _jsx("p", { children: t('recipeDetail.notifyIngredientsDescription') })] }));
});
export default NotifyIngredients;
